import React from 'react';
import { observer } from 'mobx-react';
import { DateUtils } from '@singularsystems/neo-core';
import { NeoGrid } from '@singularsystems/neo-react';
import { MinimumShareholdingSummary } from "../../../Models/Trading/Lookups/MinimumShareholdingSummary";

interface IMinShareholdingSummaryProps {
    minimumShareholdingSummary: MinimumShareholdingSummary;
}

@observer
export default class MinShareholdingSummary extends React.Component<IMinShareholdingSummaryProps> {

    constructor(props: IMinShareholdingSummaryProps) {
        super(props);
    }

    public render() {
        const { minimumShareholdingSummary } = this.props;

        return (
            <div className="portfolio-group-container">
                <div className="portfolio-group-header">
                    <div className="portfolio-group-title">
                        Minimum Shareholding Requirement Summary
                    </div>
                    <p className="my-3" style={{ whiteSpace: "pre-wrap" }}> 
                        {`Please note that you are subject to MSR requirements, as previously communicated.\n` + 
                        `Your MSR requirements have to be met by ${DateUtils.format(minimumShareholdingSummary.msrDueDate!, 'dd MMM yyyy' )}.\n` + 
                        `This shows you a summary of your current MSR status. If you pledge any of your future vestings it will be added to this and will show the impact.`}
                    </p>
                </div>
                    <>
                    <NeoGrid.Grid items={[minimumShareholdingSummary]} >
                        {(minimumShareholdingSummary, meta) =>
                            <NeoGrid.RowGroup expandProperty={meta.isExpanded} hideExpandButton={minimumShareholdingSummary.pledgedTrades.length === 0}>
                                <NeoGrid.Row>
                                    <NeoGrid.Column display={meta.sharesHeld} label="Shares held in personal capacity"/>
                                    <NeoGrid.Column display={meta.sharesHeldInstrumentPrice} />
                                    <NeoGrid.Column display={meta.currentShareholdingValue} /> 
                                    <NeoGrid.Column display={meta.totalMinimumShareholdingRequirementValue} />
                                    <NeoGrid.Column display={meta.remainingMinimumShareholdingRequirementValue} />
                                </NeoGrid.Row>
                                <NeoGrid.ChildRow>
                                    <NeoGrid.Grid items={minimumShareholdingSummary.pledgedTrades}>
                                        {(item, meta) => (
                                            <NeoGrid.Row>
                                                <NeoGrid.Column display={meta.incentiveSchemeName} />
                                                <NeoGrid.Column display={meta.tradeDate} />
                                                <NeoGrid.Column display={meta.quantity} />
                                                <NeoGrid.Column display={meta.marketPrice} />
                                                <NeoGrid.Column display={meta.value} />
                                            </NeoGrid.Row>
                                        )}
                                    </NeoGrid.Grid>
                                </NeoGrid.ChildRow>
                            </NeoGrid.RowGroup>
                        }
                    </NeoGrid.Grid>
                </>
                <div className="portfolio-group-footer">
                    <br />
                </div>
            </div>
        );
    }
}